/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ commune: NonNullable<unknown>, district: NonNullable<unknown>, ward: NonNullable<unknown> }} Carrier_Legacy_Search_HitInputs */

const vi_carrier_legacy_search_hit = /** @type {(inputs: Carrier_Legacy_Search_HitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.commune}, ${i?.district} → nay là ${i?.ward}`)
};

/**

* @param {Carrier_Legacy_Search_HitInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_legacy_search_hit = /** @type {((inputs: Carrier_Legacy_Search_HitInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Legacy_Search_HitInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_legacy_search_hit(inputs)
});